import * as _ from 'radashi'

export function gen_id(str?: string): string | undefined {
	return str && _.dash(str.replace(/[^a-zA-Z0-9 ]/g, ''))
}
